module.exports = {
          srcSet: __webpack_public_path__ + "public/images/ef222def7d0ad5adf4aefa434c853704-380.webp"+" 380w",
          images:[ {path: __webpack_public_path__ + "public/images/ef222def7d0ad5adf4aefa434c853704-380.webp",width: 380,height: 253}],
          src: __webpack_public_path__ + "public/images/ef222def7d0ad5adf4aefa434c853704-380.webp",
          toString:function(){return __webpack_public_path__ + "public/images/ef222def7d0ad5adf4aefa434c853704-380.webp"},
          
          width: 380,
          height: 253
        }